export const formatChars = {
  Y: '[0-9]',
  m: '[0-1]',
  M: '[0-9]',
  d: '[0-3]',
  D: '[0-9]',
};
